export const ECLIPSE_MOBILE_MODULE_NAME = 'eclipse-package-picker-mobile-module';
//# sourceMappingURL=moduleNames.js.map